import { Option } from 'component/Select/Option'
import { observer } from 'mobx-react-lite'
import { FilterButton } from 'page/catalog/FilterButton/FilterButton'
import { FilterStore } from 'page/catalog/store/FilterStore'

type FilterProps = {
  filter: FilterStore
  buttonPadSmall?: boolean
  options: (string | Option)[]
  inline?: boolean
  onOpen?: () => void
}

export const Filter = observer(
  ({ filter, options, buttonPadSmall, inline, onOpen }: FilterProps) => {
    const options_ = options.map((it) =>
      typeof it == 'string' ? { value: it, label: it } : it
    )

    if (options.length < 2) return null

    return (
      <FilterButton
        filter={filter}
        options={options_}
        buttonPadSmall={buttonPadSmall}
        inline={inline}
        onOpen={onOpen}
      />
    )
  }
)
